import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthHelper } from '../../../authHelper/authHelper';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { SeleccionService } from '../../servicios/seleccion.service';
import { CasClient } from '../../casClient/CasClient';


@Component({
  selector: 'app-ingreso-public',
  templateUrl: './ingreso-public.component.html',
  styleUrls: ['./ingreso-public.component.css']
})
export class IngresoPublicComponent implements OnInit {

  correo: string;

  constructor(private ruta: Router, private srvSelect: SeleccionService, private casclient: CasClient, private alerti: AlertifyService) { }

  async ngOnInit() {
    if (!this.casclient.getLogin()) {
      this.casclient.saveTicket();
      await this.casclient.verificaLogin().then();
    }
    if (this.casclient.isAuthenticated() && this.casclient.getLogin()) {
      this.obtenerDatosCentralizada();
    }
  }

  obtenerDatosCentralizada() {
    this.srvSelect.personaCentralCorreo(this.casclient.getLogin()).subscribe(data => {
      if (data.success) {
        this.obtenerPersonaID(data.listado[0].per_id);
      } else {
        this.ruta.navigate(['/']);
      }
    });
  }

  obtenerPersonaID(id: string) {
    this.srvSelect.personaCentralId(id).subscribe(data => {
      if (data.success) {
        localStorage.setItem('ciUsuario', data.datos['pid_valor']);
        this.verRolesUsuario(data.datos['pid_valor']);
      } else {
        this.alerti.warning('Su cuenta de correo no está registrado, actualice los datos por favor');
        this.ruta.navigate(['/']);
      }
    });
  }
  verRolesUsuario(usuario: string) {
    localStorage.setItem("localCargar", "0");
    this.srvSelect.gestionRoles(1, usuario, 'na').subscribe(res => {
      if (res.success) {
        if (res.roles[0]["intIdRol"] == 1)
          this.ruta.navigate(['/inicio']);
        else if (res.roles[0]["intIdRol"] == 2)
          this.ruta.navigate(['/becario']);
        else
          this.ruta.navigate(['/gestion']);
        localStorage.setItem("idUser", res.roles[0]["intIdRol"]);
      }
      else {
        this.ruta.navigate(['/becario']);
        //this.cargarCarreras(usuario);
      }
    });
  }
  //FUNCION DE DETERMINA LA CARRERA DONDE SE ENCUENTRA MATRICULADO EL ESTUDIANTE
  async cargarCarreras(documento) {
    let cont: number = 0; let banRol: boolean = false;

    const resMat = await new Promise<any>(resolve =>
      this.srvSelect.gestionMatricula(1, 'na', documento.replace('-', ''), 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resMat.success) {
      while (cont < resMat.matricula.length) {
        const matr = await new Promise<any>(resolve =>
          this.srvSelect.gestionMatricula(3, resMat.matricula[cont]['carrera'], documento.replace('-', ''), 'na', 'na').subscribe(translated => {
            resolve(translated)
          }));
        if (matr.success) {
          this.ruta.navigate(['/becario']);
          cont = resMat.matricula.length; banRol = true;
        }
        cont++;
      }
    }
    if (!banRol) {
      this.alerti.error("Usted no dispone de una de usuario activa o no tiene matrícula vigente en la ESPOCH.");
      this.ruta.navigate(['/']);
    }
  }
}
